import * as Sentry from "@sentry/react";
import { ERROR_MONITOR_DSN } from "../config/config";

export const initErrorMonitoring = () => {
  try {
    if (process.env.NODE_ENV === "production") {
      Sentry.init({
        dsn: ERROR_MONITOR_DSN,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration(),
        ],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
      });
    }
  } catch (error) {
    console.error("Error monitoring initialization failed", error);
  }
};

export const captureException = (error) => {
  try {
    Sentry.captureException(error);
  } catch (error) {
    console.error("Error monitoring capture exception failed", error);
  }
};
